module.exports = __webpack_public_path__ + "img/logo-white.b33a3ad6.svg";